import { render, staticRenderFns } from "./OptionsDialog.vue?vue&type=template&id=0b0aacbf&scoped=true&"
import script from "./OptionsDialog.vue?vue&type=script&lang=ts&"
export * from "./OptionsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./OptionsDialog.vue?vue&type=style&index=0&id=0b0aacbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0aacbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCardText,VOverlay,VScrollYTransition})
